<template>
  <div class="upload-row">
    <div class="upload-label">
      {{ title }}:
    </div>

    <div class="upload-content">
      <Dashboard
        v-if="uppy"
        :uppy="uppy"
        :props="dashboardProps"
      />

      <div class="upload-actions">
        <v-btn
          text
          color="primary"
          @click="onCancel"
        >
          Cancel
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import Uppy from '@uppy/core'
import Tus from '@uppy/tus'
import { Dashboard } from '@uppy/vue'

import '@uppy/core/dist/style.css'
import '@uppy/dashboard/dist/style.css'

export default {
  name: 'Upload3rdParty2',
  components: { Dashboard },
  props: {
    fieldKey: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      default: '',
    },
    autoUpload: {
      type: Boolean,
      default: true,
    },
  },

  data () {
    return {
      uppy: null,
      files: [],
      successful: [],
      failed: [],
      alertFailure: false,
    }
  },

  computed: {
    dashboardProps () {
      return {
        inline: true,
        height: 160,
        hideUploadButton: true,
        hideRetryButton: true,
        hidePauseResumeButton: true,
        hideCancelButton: true,
        showSelectedFiles: true,
        theme: 'dark',
        note: 'PDF only (max 4MB)',
      }
    },
  },

  mounted () {
  // 1️⃣ Create Uppy instance
    this.uppy = new Uppy({
      id: `cms-${this._uid}`,
      autoProceed: this.autoUpload,
      allowMultipleUploadBatches: false,
      restrictions: {
        maxNumberOfFiles: 1,
        maxTotalFileSize: 4 * 1024 * 1024,
        allowedFileTypes: ['application/pdf', 'image/*'],
      },
    }).use(Tus, {
      endpoint: 'https://onesys.onexox.my/files/',
    })

    // 2️⃣ Keep local files list in sync (optional but useful)
    this.uppy.on('file-added', () => {
      this.files = this.uppy.getFiles()
    })

    this.uppy.on('file-removed', () => {
      this.files = this.uppy.getFiles()
    })

    // 3️⃣ IMPORTANT: Use `complete` (Tus guarantees uploadURL here)
    this.uppy.on('complete', (result) => {
      if (!result || !result.successful || !result.successful.length) {
        console.warn('[UPLOAD] complete fired but no successful files')
        return
      }

      const file = result.successful[0]

      if (!file.uploadURL) {
        console.error('[UPLOAD] uploadURL missing after complete', file)
        return
      }

      // Example uploadURL:
      // https://onesys.onexox.my/files/uppy-ucr/form///onexapp/.../fe5e34d05d3c4154beac6622404d23c6
      const tusId = file.uploadURL.split('/').filter(Boolean).pop()
      const url = `https://onesys.onexox.my/files/${tusId}`

      // 🔥 Emit value for FormStep validation
      this.$emit('input', {
        uploaded: true,
        url,
        name: file.name,
      })

      // 🔥 Emit event for parent (PayoutMethod)
      this.$root.$emit('uploaded-ready', {
        fieldKey: this.fieldKey,
        files: [file],
        urls: [url],
      })

      console.log('[UPLOAD] completed & normalized', {
        fieldKey: this.fieldKey,
        url,
        name: file.name,
      })
    })
  },

  beforeDestroy () {
    this.uppy?.close()
  },

  methods: {
    onCancel () {
      // ✅ THIS NOW WORKS
      this.uppy.cancelAll()

      this.files = []
      this.successful = []
      this.failed = []

      // clear parent field
      this.$emit('input', null)

      // notify parent validator
      this.$emit('uploaded-ready', {
        fieldKey: this.fieldKey,
        files: [],
        urls: [],
        reset: true,
      })
    },
  },
}

</script>

<style>
.custom-loader { animation: loader 1s infinite; display: flex; }
@keyframes loader { from { transform: rotate(0); } to { transform: rotate(360deg); } }

.upload-row {
  display: flex;
  align-items: flex-start;
}

.upload-label {
  width: 25%;
  padding-top: 8px;
  font-weight: 500;
}

.upload-content {
  width: 70%;
}

.upload-actions {
  width: 100%;                 /* important */
  display: flex;
  justify-content: flex-end;   /* push button to right */
  margin-top: 8px;
}

</style>
